import { Slider } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { createRoot } from 'react-dom/client';
import urlUtis from '../../utils/url.util';
import _productApis from '../../apis/product.api';
import './_style.scss';
import globalUtils from '../../utils/global.util';

const ProductPriceSlide = ({ categoryCode }) => {
    const [rangeValue, setRangeValue] = useState([0, 0]);
    const [minValue, setMinValue] = useState(0);
    const [maxValue, setMaxValue] = useState(0);

    const fetchData = async () => {
        const { status, data } = await _productApis.getMinMaxPrice({
            categoryCode,
        });
        if (status !== 200) {
            setRangeValue([0, 0]);
            return;
        }

        const urlParams = new URLSearchParams(window.location.search);
        const max = urlParams.get('maxPrice');
        const min = urlParams.get('minPrice');

        setMinValue(data.data.minPrice);
        setMaxValue(data.data.maxPrice);

        if (max && min) {
            setRangeValue([min, max]);

            return;
        }
        setRangeValue([data.data.minPrice, data.data.maxPrice]);

        //console.log(res);
    };

    useEffect(() => {
        fetchData();
    }, []);

    const handleChange = (s) => {
        setRangeValue(s);
    };

    const doApply = () => {
        if (rangeValue.length === 0) return;
        urlUtis.insertMultiParam([
            {
                key: 'minPrice',
                value: rangeValue[0],
            },
            {
                key: 'maxPrice',
                value: rangeValue[1],
            },
        ]);
    };
    return (
        <aside className="widget widget_by_price">
            <h3 className="widget-title">Giá bán</h3>

            <div className="layout-slider product-slider">
                <Slider
                    range
                    value={rangeValue}
                    tooltip={{
                        open: true,
                        placement: 'bottom',
                        formatter: (value) => {
                            return (
                                <span>
                                    {globalUtils.formatNumberToPrice(value)}
                                </span>
                            );
                        },
                    }}
                    onChange={handleChange}
                    max={maxValue}
                    step={1000}
                />
            </div>
            <a className="link-v1 space-30" onClick={doApply} title="fillter">
                ÁP DỤNG
            </a>
        </aside>
    );
};

export default ProductPriceSlide;

document
    .querySelectorAll('react-product-price-slide')
    .forEach((domContainer) => {
        const root = createRoot(domContainer);
        const categoryCode = domContainer.dataset.categoryCode;
        root.render(<ProductPriceSlide categoryCode={categoryCode} />);
    });
